import styled from "styled-components";
import { rotate360 } from "./AnimationRotate";
import { Button } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";

export const Spinner = styled.div`
  margin: 16px;
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 2px solid grey;
  border-right: 2px solid grey;
  border-bottom: 2px solid grey;
  border-left: 4px solid black;
  background: transparent;
  width: 80px;
  height: 80px;
  border-radius: 50%;
`;

export const TextField = styled.input`
  height: 34px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
  &:hover {
    cursor: pointer;
  }
`;

export const ClearButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableContainer = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
`;

export const SearchWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 32px;
`;

export const TextFieldWithIcon = styled.input`
  height: 42px;
  width: 225px;
  padding: 0 32px 0 32px;
  border: 1px solid #e5e5e5;
  border-radius: 5px 0 0 5px;
`;

export const Icon = styled(FiSearch)`
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  pointer-events: none;
  color: #999;
`;

export const ClearButtonFilter = styled.button`
  border: 1px solid #e5e5e5;
  border-left: none;
  border-radius: 0 5px 5px 0;
  height: 42px;
  width: 32px;
  background: #fff;
  cursor: pointer;
`;